/** Single source of truth for in-page nav: hash, DOM id, and scroll-spy key.
 *  Section order here drives Main.js rendering via sectionComponents in
 *  components/sections/index.js — keep ids aligned. */
export const navSections = [
  { id: "home", label: "Home", navSection: "home" },
  { id: "about", label: "About", navSection: "about" },
  { id: "skills", label: "Skills", navSection: "skills" },
  { id: "services", label: "Services", navSection: "services" },
  { id: "education", label: "Education", navSection: "education" },
  { id: "experience", label: "Experience", navSection: "experience" },
  { id: "work", label: "Work", navSection: "work" },
  { id: "certifications", label: "Certifications", navSection: "certifications" },
  { id: "achievements", label: "Achievements", navSection: "achievements" },
  { id: "contact", label: "Contact", navSection: "contact" },
];

export const navSectionIds = navSections.map((section) => section.navSection);
